<template> 
    <div > 
        <div class="crumbs" hidden="true" style="margin-left:10px;" >
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-calendar"></i> 商品管理
                </el-breadcrumb-item>
                 <el-breadcrumb-item>限单配置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container" v-loading="loading2" element-loading-text="正在保存商品数据" element-loading-spinner="el-icon-loading">   
            <el-form ref="form3" :model="form4" style="margin-top:-20px；" label-width="0"> 
                <span class="label-span"  style="display:block;margin-top:-10px">
                    <label class="label">风控级别</label> 
                    <el-radio-group  v-model.trim="form4.riskLevel" :disabled="config.edit" @change="riskChange()" >
                        <el-radio-button label="0">资源级风控</el-radio-button> 
                        <el-radio-button label="1">产品级风控</el-radio-button> 
                    </el-radio-group>  
                </span>   
                <span class="label-span"  style="display:block;margin-top:10px">
                    <label class="label">转化率指标</label> 
                    <el-checkbox-group v-model="riskIndexs" :disabled="config.edit" @change="riskChange()" size="mini" style="display:inline-block;margin-left:15px;">
                        <el-checkbox label="9" >订购成功</el-checkbox>
                        <el-checkbox label="6"  >回填成功</el-checkbox>
                        <el-checkbox label="-1" >订购失败</el-checkbox>
                    </el-checkbox-group>
                </span>    
                <span class="label-span" style=" margin-top:10px" >
                    <label class="label">整体风控值</label> 
                    <el-input  v-model.trim="form4.riskTotalNum" oninput="value=value.replace(/[^\d]/g,'')" :disabled="config.edit" @change="riskChange()" placeholder="整体风控值" style="width:105px;" class="handle-input mr10"></el-input>
                </span>   
                <span class="label-span" style=" margin-top:10px" >
                    <label class="label">风控转化率</label> 
                    <el-input  v-model.trim="form4.riskRate" oninput="value=value.replace(/[^\d]/g,'')" :disabled="config.edit" @change="riskChange()" placeholder="最低转化率监控" style="width:105px;" class="handle-input mr10"></el-input>%
                </span>    
                    <el-tooltip  content="点击解开编辑权限" placement="top">
                <i style="color:#fff;font-size:25px;vertical-align:middle;cursor:pointer;color: #409eff;float:right;margin-right:15px;margin-top:10px" class='el-icon-edit-outline'  @click="setConfigEdit()"></i>
                </el-tooltip>
                <!-- <el-tooltip  content="点击撤回所有操作" placement="top">
                    <i class='el-icon-back' style="font-size:25px;cursor:pointer;" ></i>
                </el-tooltip> --> 
            </el-form>
            <div  style="border: 1px dashed #409EFF;background:#ecf5ff;padding:15px 10px;margin-top:15px;">
                <div style="margin-bottom:10px;"> 
                    <span class="label-span2">
                        <label class="label2" >渠道名称</label> 
                        <el-input v-model.trim="query2.loginName" placeholder="下游渠道名称" style="width:120px;" class="handle-input mr10"></el-input> 
                    </span>
                    <span class="label-span2">
                        <label class="label2">渠道号码</label> 
                        <el-input v-model.trim="query2.memPhone" placeholder="下游渠道号码" style="width:120px;" class="handle-input mr10"></el-input> 
                    </span>     
                    <el-button type="success"  @click="handleSearch2">搜索</el-button>
                    <el-button type="error"   @click="refreshSearch2">重置</el-button> 
                </div>
                <el-table   :data="tableData2" border class="table"  ref="multipleTable" header-cell-class-name="table-header"  
                v-loading="loading4" style="max-height:450px;overflow-y:scroll"  element-loading-text="请稍等..." element-loading-spinner="el-icon-loading" > 
                    <el-table-column prop="loginName"  min-width="100" align="left" label="渠道名称"></el-table-column>
                    <el-table-column prop="memPhone"  min-width="110" align="center" label="渠道号码"></el-table-column> 
                    <el-table-column prop="isSm"  min-width="130" align="center" label="渠道风控值">
                        <template slot-scope="scope" > 
                            <el-input  v-model.trim="scope.row.riskNum" oninput="value=value.replace(/[^0-9.]/g,'')" @change="setMemRiskConfig(scope.row)" :disabled="config.edit" placeholder="渠道风控值" style="width:105px;" class="handle-input mr10"></el-input>
                        </template>  
                    </el-table-column> 
                    <el-table-column prop="isSm" min-width="160" align="left" label="渠道转化率">
                        <template slot-scope="scope" >  
                            <el-input  v-model.trim="scope.row.riskPercent" oninput="value=value.replace(/[^0-9.]/g,'')" @change="setMemRiskConfig(scope.row)" :disabled="config.edit" placeholder="渠道转化率" style="width:105px;" class="handle-input mr10"></el-input> %
                        </template>  
                    </el-table-column>   
                    <el-table-column prop="riskStatus"  width="90" align="center" label="风控状态">
                    <template slot-scope="scope" > 
                         <el-tooltip :content="scope.row.riskStatus=='1'?'风控关停':'风控通过'" placement="top">
                            <el-switch @change="handleStatus4(scope.row)" :disabled="editLock"
                                v-model="scope.row.riskStatus"
                                active-color="red"
                                inactive-color="#67C23A"
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template>  
                </el-table-column>     
                <el-table-column prop="status" align="center"  min-width="100" label="分配状态">
                    <template slot-scope="scope" > 
                         <el-tooltip :content="scope.row.status=='1'?'已分配':'未分配'" placement="top">
                            <el-switch @change="handleStatus2(scope.row)" :disabled="editLock"
                                v-model="scope.row.status"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template>  
                </el-table-column>   
                </el-table>  
                <div class="pagination">
                    <el-pagination  background layout="total,  sizes,prev, pager, next,jumper"
                        :page-sizes="[10,20]"
                        :current-page="query2.pageIndex"
                        :page-size="query2.pageSize"
                        :total="pageTotal2"
                        @size-change="handleSizeChange2"
                        @current-change="handlePageChange2" 
                    ></el-pagination>
                </div> 
            </div>  
        </div>
     

         
    </div>
 
</template> 

<script>
import $ from 'jquery' ; 
import bus from '../common/bus';  
import { fetchData3,setRiskConfig,setMemRisk, changeStatus,getRiskData } from '../../api/comGoods';   
 import { changeStatus2,changeStatus4 } from '../../api/member';
  
export default {

    data() {
        return {   
             
            goodsCode:'', 
            orderDis:true,
            config:{
                wid:'800px',
                top:'50px',
                edit:true,
            }, 
            riskIndexs:[],
            configVisible:false,
            contentVisible:false,
            sureImgVisible:false, 
            sureImgVisible2:false, 
            saveContent:'0',
            contentVal:'',
            infoVisible:false,
            loading:false,
            loading2:false,
            loading3:false, 
            loading4:false, 
            query: { 
                pageIndex: 1,
                pageSize: 10,  
            }, 
            query2: { 
                pageIndex: 1,
                pageSize: 10,   
            },  
            tableData: [],
            tableData2: [], 
            skuCodes:[], 
            form4:{},
            idx: -1,
            id: -1
        };
    },
 
    beforeDestroy() {
        // 记得移除监听，避免内存泄漏
        bus.$off('risk-method');
    },
    created() { 
        bus.$on('risk-method',  goodsCode  => { 
            this.config.edit = true; 
            this.$set(this.config, 'edit',true); 
            this.initRiskConfig(goodsCode);
        });
    },
    //页面加载方法
    mounted: function () { 
        //this.limitConfig();
        
    },
    

    methods: { 
        setEdit(){ 
            if(this.orderDis){
                this.orderDis = false;
            }else{
                this.orderDis = true;
            } 
        },
        setConfigEdit(){ 
            if(this.config.edit){
                this.$confirm('解开编辑权限后，修改的所有数据都将实时保存，确定要解开吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.config.edit = false;
                }) 
            }else{
                this.config.edit = true;
               
            }
        },
        numFilter(value) { 
            const realVal = parseFloat(value).toFixed(2); 
            return realVal; 
        },  
        initRiskConfig(goodsCode){        
            this.goodsCode = goodsCode;  
            this.getData2();  
            this.configVisible = true;  
            let data = {};
            data.goodsCode = goodsCode;
            getRiskData(data).then(res => {   
                if(res.code=='200'){  
                    this.form4 = res.data;  
                    this.riskIndexs = this.form4.riskIndex.split(","); 
                }else{
                    this.$notify({ title: '失败', message: '转化率风控数据拉取失败：'+res.message,duration: 3000, type: 'error' });
                }
            }); 
        }, 
        LimitNumChange(){ 
            this.changeGiveNum(); 
        },  
        riskChange(){   
            if(this.riskIndexs=='' || this.riskIndexs==null || this.riskIndexs==undefined ){
                this.$message.error("请勾选转化率指标"); 
                return;
            }
            if(this.form4.riskTotalNum<100){
                this.$message.error("整体风控值不小于 100"); 
                return;
            }
            if(this.form4.riskRate>99){
                this.$message.error("整体风控值不超过 99%"); 
                return;
            }
             
            var num = 0;
            for(var i=0;i<this.tableData2.length;i++){ 
                num+=parseInt(this.tableData2[i].riskNum); 
            } 
            if(this.form4.riskTotalNum<num){
                this.$message.error("整体风控值不得小于渠道风控制之和！");
                return;
            } 
            this.form4.riskIndex =  this.riskIndexs.join();
            if(this.form4.riskIndex.charAt(0) === ','){
                this.form4.riskIndex = this.form4.riskIndex.substring(1);
            } 
            setRiskConfig(this.form4).then(res => {   
                if(res.code=='200'){  
                    this.$notify({ title: '成功', message: '整体风控设置成功',duration: 1000, type: 'success' });
                    this.initRiskConfig(this.form4.goodsCode);
                }else{
                     this.$notify({ title: '失败', message: '整体风控设置失败：'+res.message,duration: 3000, type: 'error' });
                }
            });
            /* */
        },
        setMemRiskConfig(row){
            if(row.riskNum<50){
                this.$message.error("渠道风控值不小于 50"); 
                return;
            }
            if(this.form4.riskPercent>99){
                this.$message.error("渠道风控值不超过 99%"); 
                return;
            }

            var num = 0;
            for(var i=0;i<this.tableData2.length;i++){ 
                num+=parseInt(this.tableData2[i].riskNum); 
            } 
            if(this.form4.riskTotalNum<num){
                this.$message.error("渠道风控制之和不得大于整体风控值！");
                return;
            } 
            setMemRisk(row).then(res => {   
                if(res.code=='200'){  
                    this.$notify({ title: '成功', message: '渠道:'+row.loginName+' 风控设置成功',duration: 1000, type: 'success' });
                    this.initRiskConfig(row.goodsCode);
                }else{
                     this.$notify({ title: '失败', message: '渠道:'+row.loginName+' 风控设置失败：'+res.message,duration: 3000, type: 'error' });
                }
            });
        },
        handleStatus2(row){
            var tips ;
            var content;
            if(row.status=='0'){ 
                row.status='1';
                tips = "取消分配"; 
            }else{ 
                row.status = '0';
                tips = "分配"; 
            }
            this.$confirm('确认'+tips+this.loginName+"-"+row.goodsName+'吗', '提示', {
                type: 'warning'
            }).then(() => {
                if(row.status=='0'){ 
                    row.status='1' 
                }else{ 
                    row.status='0' 
                }
                row.memId = row.mid;
                changeStatus2(row).then(res => {   
                    if(res.code=='200'){  
                        this.initRiskConfig(row.goodsCode);
                        this.$notify({ title: '成功', message: row.goodsName+tips+'成功',duration: 1000, type: 'success' }); 
                    }else{
                        if(row.status=='0'){ 
                            row.status='1'   
                        }else{ 
                            row.status='0' 
                        }
                        this.$notify({ title: '失败', message: row.goodsName+tips+'失败：'+res.message,duration: 5000, type: 'error' });  
                    }
                });
            });
        },
        handleStatus4(row){
            var tips ;
            var content;
            if(row.riskStatus=='0'){ 
                row.riskStatus='1';
                tips = "重启风控"; 
            }else{ 
                row.riskStatus = '0';
                tips = "风控关停"; 
            }
            this.$confirm('确认'+tips+this.loginName+"-"+row.goodsName+'吗', '提示', {
                type: 'warning'
            }).then(() => {
                if(row.riskStatus=='0'){ 
                    row.riskStatus='1' 
                }else{ 
                    row.riskStatus='0' 
                }
                row.memId = row.mid;
                changeStatus4(row).then(res => {   
                    if(res.code=='200'){   
                        this.initRiskConfig(row.goodsCode);
                        this.$notify({ title: '成功', message: row.goodsName+tips+'成功',duration: 1000, type: 'success' }); 
                    }else{
                        if(row.riskStatus=='0'){ 
                            row.riskStatus='1' 
                        }else{ 
                            row.riskStatus='0' 
                        }
                        this.$notify({ title: '失败', message: row.goodsName+tips+'失败：'+res.message,duration: 5000, type: 'error' });  
                    }
                });
            });
        }, 

        //获取下拉框数据
        getSelect(){ 
            this.select = {};  
            fetchSelect(this.select).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select, 'option', res.data);  
                }
            });
        },
        getSelect1(){ 
            this.select1 = {};  
            fetchSelect1(this.select1).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select1, 'option', res.data);  
                }
            });
        },
        getSelect2(){ 
            this.select2 = {}; 
            fetchSelect2(this.select2).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select2, 'option', res.data);  
                }
            });
        },
        getSelect3(){ 
            this.select3 = {}; 
            fetchSelect3(this.select3).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select3, 'option', res.data);  
                }
            });
        },
        getSelect4(){ 
            this.select4 = {}; 
            fetchSelect4(this.select4).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select4, 'option', res.data);  
                }
            });
        },
        getSelect5(){ 
            this.select5 = {};  
            fetchSelect5(this.select5).then(res => {   
                if(res.code=='200'){  
                    this.$set(this.select5, 'option', res.data);  
                }
            });
        },
        getSelect6(ctype){ 
            this.select6 = {}; 
            this.select6.ctype = ctype;
            fetchSelect6(this.select6).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select6, 'option', res.data);  
                }
            });
        },
        getSelect7(){ 
            this.select7 = {};  
            fetchSelect7(this.select7).then(res => {   
                if(res.code=='200'){  
                    this.$set(this.select7, 'option', res.data);  
                }
            });
        },
         downExcel(){
             this.$confirm('确定要下载吗？', '提示', {
                type: 'warning'
            }).then(() => {
                this.loading3 = true;
                var host = localStorage.getItem(window.location.hostname+'_stationUrl'); 
                //var link = "http://"+localStorage.getItem(window.location.hostname+'_indexUrl')+"/h5/templateCode_mid/goodsCode/memCode"; 
                this.query.link1 = "http://"+host+"/h5/cl/code2_2/";
                this.query.link2 = "http://"+host+"/h5/goodsDoc/2/";
                setTimeout( () => {
                    this.loading3 = false;  
                    this.getData();
                }, 7000) 
                downOrderExcel(this.query).then(res => {   
                    this.loading3 = false
                    if(res.code=='200'){ 
                        this.$notify({ title: '成功', message: '后台下载成功',duration: 1000, type: 'success' });
                    }else{
                        this.$notify({ title: '失败', message: '后台下载异常',duration: 1000, type: 'error' });
                    }
                });
            });
        },
         getLink2(name,goodsCode){  
            var host = localStorage.getItem(window.location.hostname+'_stationUrl');
            var mid = localStorage.getItem(window.location.hostname+'_mid');
            //var link = "http://"+localStorage.getItem(window.location.hostname+'_indexUrl')+"/h5/templateCode_mid/goodsCode/memCode";
            var link = name+"： http://"+host+"/h5/cl/code2_2/"+goodsCode;
            this.copyLink(link,name);
        },

        getLink1(name,goodsCode){  
            var host = localStorage.getItem(window.location.hostname+'_stationUrl');
            var mid = localStorage.getItem(window.location.hostname+'_mid');
            //var link = "http://"+localStorage.getItem(window.location.hostname+'_indexUrl')+"/h5/templateCode_mid/goodsCode/memCode";
            var link = name+"： http://"+host+"/h5/goodsDoc/2/"+goodsCode;
            this.copyLink(link,name);
        },
         
        // 触发搜索按钮 
        handleSearch() {
            if(this.query.goodsTag){
                this.query.goodsTags = this.query.goodsTag.join();
            }else{
                this.query.goodsTags = "";
            }
            if(this.query.promoteArea){
                this.query.promoteAreas = JSON.stringify(this.query.promoteArea);
            }else{
                this.query.promoteArea = "";
            } 
            if(this.query.goodsId){
                this.query.goodsIds = this.query.goodsId.join();
            }else{
                this.query.goodsIds = "";
            } 
            this.$set(this.query, 'pageIndex', 1);
            this.getData(); 
        },
        refreshSearch2() {
            this.$set(this.query2, 'loginName');
            this.$set(this.query2, 'memPhone');   
            this.$set(this.query2, 'pageIndex', 1);
            this.getData2();
        },
        handleSearch2(){ 
            this.getData2();
        },
        getData2(){
            // 获取列表数据   
            this.loading4 = true;
            this.query2.goodsCode = this.goodsCode;
            fetchData3(this.query2).then(res => {  
                this.loading4 = false;
                if(res.code=='200'){  
                    this.tableData2 = res.data.list;
                    this.pageTotal2 = res.data.pageTotal || 0;   
                }else{
                    this.tableData2 = []; 
                    this.pageTotal2 = 0;
                } 
                
            });
        },
        //查询商品id
        search(channelCode){
            let param = {};
            param.channelCode = channelCode;
            param.mid = this.mid;
            param.stationId = this.stationId;
            getSkuCodes(param).then(res => {   
                if(res.code=='200'){  
                    this.skuCodes = res.data.list;
                    this.skuVisible = true;
                }else{
                    this.$message.error(res.message); 
                }
            });
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'ctype'); 
            this.$set(this.query, 'channelCode' ); 
            this.$set(this.query, 'channelGoodsName'); 
            this.$set(this.query, 'channelGoodsCode');  
            this.$set(this.query, 'goodsRate');  
            this.$set(this.query, 'isp' );   
            this.$set(this.query, 'goodsName');  
            this.$set(this.query, 'goodsCode');  
            this.$set(this.query, 'goodsType');  
            this.$set(this.query, 'goodsFrom');  
            this.$set(this.query, 'goodsComType');  
            this.$set(this.query, 'status');  
            this.$set(this.query, 'promoteStatus');  
            this.$set(this.query, 'promoteArea');  
            this.$set(this.query, 'goodsTag');   
            this.$set(this.query, 'promoteAreas');  
            this.$set(this.query, 'goodsTags');   
            this.$set(this.query, 'goodsId');   
            this.handleSearch();
        },  

         //刷新
        refresh(){
            history.go(0); 
        },
        getImgDetail(goodsCode){ 
            this.imgUrl = "https://"+localStorage.getItem('ms_indexUrl')+"/hk/imgDetail?st="+this.stationId+"&gc="+goodsCode;
            var height = document.body.scrollHeight; 
            this.imgHeight = height*0.8; 
            this.imgVisible=true;
        },

        //查询
        getData(){
            // 获取列表数据   
            this.loading3 = true;
            fetchData(this.query).then(res => {  
                this.loading3 = false;
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal || 0;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        }, 
        getInfoDetail(goodsCode){
            this.imgUrl = "https://"+localStorage.getItem('ms_indexUrl')+"/hk/infoDetail?st="+this.stationId+"&gc="+goodsCode;
            this.infoVisible=true;
        },
         
        //复制
        handleCopy(index, row){
            row.mid = this.mid;
            row.stationId = this.stationId; 
            handleCopy(row).then(res => {
                if(res.code=='200'){
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    //处理该等级绑定的成员
                    this.$message.error(res.message); 
                } 
            }); 
        },
        //详情
        handDetail(index, row){
            $("#input_box3").html(row.goodsMore);
            //查询商品详情
            let detailParam = {};
            detailParam.stationId = this.stationId;
            detailParam.mid = this.mid;
            detailParam.goodsCode = row.goodsCode;
            backDetailImg(detailParam).then(res => {
                if(res.code=='200'){
                    this.detailImg = res.data; 
                }else{ 
                    this.$message.error(res.message); 
                }  
            });
            this.form3 = row;   
            this.detailVisible = true;   
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val; 
        },
        // 删除
        handDelete(index, row) { 
            row.stationId = this.stationId;  
            row.mid = this.mid;
           
            // 二次确认删除
            this.$confirm('确定要删除 《 '+row.goodsName+' 》 吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功'); 
                        this.getData();
                    }else{
                        this.$message.error(res.message); 
                    } 
                });
            }) 
        },
        //批量删除
        changeGrade() {
            const length = this.multipleSelection.length; 
            if(length===0){
                this.$message.error("请勾选要删除的商品");
                return;
            }
            var that = this;
            let param = {};
            let goodsCodes = ''; 
            let goodsNames = ''; 
            let title = ''; 
            let ids = '';
            that.delList = that.delList.concat(that.multipleSelection);
            for (let i = 0; i < length; i++) {
                goodsCodes += that.multipleSelection[i].goodsCode + ','; 
                ids += that.multipleSelection[i].id + ','; 
                goodsNames += that.multipleSelection[i].goodsName + ','; 
                title += that.multipleSelection[i].goodsName + '》,《'; 
            }  
                param.goodsCodes = goodsCodes.substr(0,goodsCodes.length-1);  
                param.ids = ids.substr(0,ids.length-1);  
                param.goodsNames = goodsNames.substr(0,goodsNames.length-1);  
                param.mid = that.mid;
                param.stationId = that.stationId;
                title = title.substr(0,title.length-3); 
            // 二次确认删除
            this.$confirm('确定要删除 《'+title+'》 吗？', '提示', {
                type: 'warning'
            }).then(() => { 
                handDeleteBatch(param).then(res => {
                    if(res.code=='200'){ 
                        that.$message.success(res.message); 
                        that.getData();
                    }else{ 
                        that.$message.error(res.message); 
                    } 
                });
            }) 
           

        }, 
         //上下架
        handleStatus(index,row){  
            if(row.status==0){
                this.loadingTitle = "下架";
            }else if(row.status==1){
                this.loadingTitle = "上架";
            } 
            this.loading = true; 
            changeStatus(row).then(res => {
                this.loading = false;
                if(res.code=='200'){  
                    this.$message.success(this.loadingTitle+"成功"); 
                    this.getData();
                }else{ 
                    this.$message.error(this.loadingTitle+"失败"); 
                }  
            }); 
        },

        handleProStatus(index,row){  
            let that = this;
            if(row.promoteStatus==0){ 
                row.promoteStatus='1';
                that.$prompt('请输入暂停推广'+row.goodsName+'原因（不超过50个字）', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',  
                    }).then(({ value }) => { 
                        row.promoteInfo = value;
                        row.promoteStatus='0';
                        that.loading = true;
                        changeStatus(row).then(res => {
                        that.loading = false;
                        if(res.code=='200'){  
                            that.$message.success(row.goodsName+"暂停推广成功"); 
                            that.getData();
                        }else{ 
                            that.$message.error(row.goodsName+"暂停推广失败:"+res.message); 
                        }  
                    });   
                }).catch(() => {
                       row.status='1'; 
                });
            }else{ 
                row.promoteInfo = '-'; 
                that.loading = true;
                changeStatus(row).then(res => {
                    that.loading = false;
                    if(res.code=='200'){  
                        that.$message.success(row.goodsName+"开启推广成功"); 
                        that.getData();
                    }else{ 
                        that.$message.error(row.goodsName+"开启推广失败:"+res.message); 
                    }  
                });
            } 
        },
 

        // 新增商品
        addBind() {   
            this.getSelect1();  
            this.getSelect2();  
            this.getSelect3(); 
            this.getSelect4(); 
            this.getSelect5();
            this.getSelect7(); 
            this.getSelect6(''); 
            this.fileList = [];
            this.getSelect6(this.query.ctype); 
            this.saveContent = "0";
            this.addVisible = true; 
        },
        validateNumberInput(input) {
            // 使用正则表达式替换非数字和小数点的字符
            input.value = input.value.replace(/[^0-9.]/g, '');

            // 确保只有一个小数点
            let parts = input.value.split('.');
            if (parts.length > 2) {
                input.value = parts[0] + '.' + parts.slice(1).join('');
            }

            // 确保不以小数点开头
            if (input.value.startsWith('.')) {
                input.value = input.value.substring(1);
            }
        },
       
        //保存新增
        saveForm() {    
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮
            if( !this.form1.channelCode ){
                this.isSubmitting = false;
                this.$message.error("请选择商品资源");
                return;
            }
            if( !this.form1.channelGoodsCode ){
                this.isSubmitting = false;
                this.$message.error("请填写商品编码");
                return;
            }
            if( !this.form1.channelGoodsName ){
                this.isSubmitting = false;
                this.$message.error("请填写商品名称");
                return;
            }  
            if( !this.form1.goodsRate ){
                this.isSubmitting = false;
                this.$message.error("请填写商品资费");
                return;
            } 
            if( !this.form1.channelCom ){
                this.isSubmitting = false;
                this.$message.error("请填写商品佣金");
                return;
            } 
            if( !this.form1.channelComType ){
                this.isSubmitting = false;
                this.$message.error("请选择结佣类型");
                return;
            }   
            if(this.form1.channelComType==2 && !this.form1.channelComTimes ){
                this.isSubmitting = false;
                this.$message.error("请填写返佣月份");
                return;
            } 
            if(!this.form1.goodsType){
                this.isSubmitting = false;
                this.$message.error("请填写产品分类");
                return;
            } 
            if(!this.form1.goodsFrom){
                this.isSubmitting = false;
                this.$message.error("请填写产品来源");
                return;
            } 
            if(!this.form1.goodsName){
                this.isSubmitting = false;
                this.$message.error("请填写产品名称");
                return;
            } 
            if(!this.form1.isp){
                this.isSubmitting = false;
                this.$message.error("请填写计费ISP");
                return;
            } 
            if(!this.form1.goodsComType){
                this.isSubmitting = false;
                this.$message.error("请填写结算类型");
                return;
            } 
            if(!this.form1.goodsCom){
                this.isSubmitting = false;
                this.$message.error("请填写产品佣金");
                return;
            } 
            if(!this.form1.goodsComType){
                this.isSubmitting = false;
                this.$message.error("请填写结算类型");
                return;
            } 
            if(this.form1.goodsComType==2 && !this.form1.goodsComTimes ){
                this.isSubmitting = false;
                this.$message.error("请填写结佣月份");
                return;
            } 
            if(this.goodsRead){ 
                this.form1.goodsRead = this.goodsRead.join();
            } 
            if(!this.goodsTag){
                this.isSubmitting = false;
                this.$message.error("请选择产品标签");
                return;
            }else{
                this.form1.goodsTag = this.goodsTag.join();
            } 
            if(this.fileList.length<1){
                this.isSubmitting = false;
                this.$message.error("请上传产品图片");
                return;
            }   
            if(!this.promoteArea || this.promoteArea==''){
                this.isSubmitting = false;
                this.$message.error("请选择推广范围");
                return;
            }else{
                
                this.form1.promoteArea = JSON.stringify(this.promoteArea);
            } 
            if(this.saveContent == "1"){
                this.form1.goodsContent = this.contentVal;
            }
            this.loading = true;  
            this.loadingTitle = "正在保存..."; 
            setTimeout( () => {
                this.loading = false;  
                this.getData();
            }, 7000)  
            saveForm(this.form1).then(res => { 
                if(res.code=='200'){   
                    this.addVisible = false;  
                    this.isSubmitting = false; 
                    //上传产品图片
                    let formData = new FormData();  
                    formData.append("goodsCode",res.data.goodsCode); 
                    formData.append("fileIds","");  
                    for(let j = 0; j < this.fileList.length; j++) {
                        formData.append("files", this.fileList[j].raw,this.fileList[j].name); 
                    }   
                    uploadDetailPlain(formData).then(res => {
                        this.loading = false;   
                        this.refreshSearch();
                        if(res.code=='200'){ 
                            this.$message.success("添加产品成功");  
                        }else{
                            this.addVisible = true;  
                            this.$message.error("产品图片上传失败！请重新编辑上传！"); 
                        }
                    }); 
                }else{
                    this.loading = false;  
                    this.isSubmitting = false; 
                    this.$message.error(res.message); 
                } 
            });
        },
        // 编辑操作
        handleEdit(index, row) {
            this.getSelect1();  
            this.getSelect2();  
            this.getSelect3(); 
            this.getSelect4(); 
            this.getSelect5();
            this.getSelect7(); 
            this.getSelect6(''); 
            let data = {};
            data.goodsCode = row.goodsCode;
            this.saveContent = "0";  
            getGoodsDetail(data).then(res => {
                if(res.code=='200'){ 
                    this.form2 = row; 
                    this.goodsTag2 = res.data.detail.goodsTag.split(",");  
                    if(res.data.detail.goodsRead!=null && res.data.detail.goodsRead!=""){
                        this.goodsRead2 = res.data.detail.goodsRead.split(","); 
                    } 
                    this.form2.smsSize = res.data.detail.smsSize;  
                    this.form2.sureContent = res.data.detail.sureContent;  
                    this.form2.sureImg = res.data.detail.sureImg;  
                    this.form2.img1 = res.data.detail.img1;  
                    this.form2.img2 = res.data.detail.img2;  
                    this.form2.img3 = res.data.detail.img3;  
                    this.form2.promoteRequire = res.data.detail.promoteRequire;  
                    if(res.data.detail.promoteArea){
                        this.promoteArea2 = JSON.parse(res.data.detail.promoteArea); 
                    } 
                    this.fileList = res.data.files;  
                    if(res.data.detail.goodsContent){ 
                        this.saveContent = '1';
                        this.contentVal = res.data.detail.goodsContent;  
                    } 
                    this.editVisible = true;
                }else{ 
                    this.$message.error(res.message); 
                } 
            });     
            
        },
        AesIdEdit(index, row){  
            let data = {};
            data.id = row.id;
            data.stationId = this.stationId;
            data.mid = this.mid;  
            data.aesId = row.aesId;
            data.goodsCode = row.goodsCode;
            updateAesId(data).then(res => {
                if(res.code=='200'){ 
                    this.getData();
                    this.$message.success(res.message);  
                }else{ 
                    this.$message.error(res.message); 
                } 
            });   
        },
        // 保存编辑
        saveEdit() {  
            if( !this.form2.channelCode ){
                this.$message.error("请选择商品资源");
                return;
            }
            if( !this.form2.channelGoodsCode ){
                this.$message.error("请填写商品编码");
                return;
            }
            if( !this.form2.channelGoodsName ){
                this.$message.error("请填写商品名称");
                return;
            }  
            if( !this.form2.goodsRate ){
                this.$message.error("请填写商品资费");
                return;
            } 
            if( !this.form2.channelCom ){
                this.$message.error("请填写商品佣金");
                return;
            }  
            if( !this.form2.channelComType ){
                this.$message.error("请选择结佣类型");
                return;
            }   
            if(this.form2.channelComType==2 && !this.form2.channelComTimes ){
                this.$message.error("请填写返佣月份");
                return;
            } 
            if(!this.form2.goodsType){
                this.$message.error("请填写产品分类");
                return;
            } 
            if(!this.form2.goodsFrom){
                this.$message.error("请填写产品来源");
                return;
            } 
            if(!this.form2.goodsName){
                this.$message.error("请填写产品名称");
                return;
            } 
            if(!this.form2.isp){
                this.$message.error("请填写计费ISP");
                return;
            } 
            if(!this.form2.goodsComType){
                this.$message.error("请填写结算类型");
                return;
            } 
            if(!this.form2.goodsCom){
                this.$message.error("请填写产品佣金");
                return;
            } 
            if(!this.form2.goodsComType){
                this.$message.error("请填写结算类型");
                return;
            } 
            if(this.form2.goodsComType==2 && !this.form2.goodsComTimes ){
                this.$message.error("请填写结佣月份");
                return;
            } 
            if(this.goodsRead){ 
                this.form2.goodsRead = this.goodsRead2.join();
            } 
            if(!this.goodsTag){
                this.$message.error("请选择产品标签");
                return;
            }else{
                this.form2.goodsTag = this.goodsTag2.join();
            } 
            if(this.fileList.length<1){
                this.$message.error("请上传产品图片");
                return;
            }  
            if(!this.promoteArea){
                this.$message.error("请选择推广范围");
                return;
            }else{
                this.form2.promoteArea = JSON.stringify(this.promoteArea2); 
            } 
            if(this.saveContent == "1"){
                this.form2.goodsContent = this.contentVal;
            }
            this.loading2 = true; 
            setTimeout( () => {
                this.loading2 = false;  
                this.getData();
            }, 5000)
            changeForm(this.form2).then(res => { 
                if(res.code=='200'){  
                    this.$message.success(res.message); 
                     //上传详情图
                    let formData = new FormData(); 
                    formData.append("goodsCode",this.form2.goodsCode); 
                    var fileIds="";
                    var fag = 0;
                    for(let j = 0; j < this.fileList.length; j++) {
                        if(this.fileList[j].raw){
                            fag = 1;
                            formData.append("files", this.fileList[j].raw,this.fileList[j].name); 
                        }else{
                            fileIds+= "'"+this.fileList[j].fileId+"',"; 
                        } 
                    }  
                    if(fileIds.length>1){fileIds=fileIds.substr(0,fileIds.length-1)}
                    formData.append("fileIds",fileIds);  
                    uploadDetailPlain(formData).then(res => { 
                        this.loading2 = false;
                        this.getData();
                        this.editVisible = false; 
                        if(res.code!='200'){
                            this.$message.error(res.message); 
                        }
                    });   
                     
                }else{
                    this.loading2 = false;
                    this.getData();
                    this.$message.error(res.message); 
                }
            });

           
        },
        copyLink(text,name){  
            var copy = document.createElement("input");
            copy.setAttribute("value", text);
            document.body.appendChild(copy);
            copy.select();
            document.execCommand("copy");
            document.body.removeChild(copy);  
            //提示已复制
            this.$message.success(name+"复制成功");  
        },

        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        },
        // 分页导航
        handlePageChange2(val) { 
            this.$set(this.query2, 'pageIndex', val);
            this.getData2();
        },
        //分页数量更改导航
        handleSizeChange2(val){
            this.$set(this.query2, 'pageSize', val);
            this.getData2();
        }
    }
};
</script>
<style> 
.chm-imgUl{
   width:560px;height:250px;margin-top:15px;
}
.chm-imgLi{
    list-style: none;
    float:left;width:100px;
    padding:0 20px;
}
.chm-imgFag{
    font-size: 35px;
    color: #ccc;
    position: relative;
    top: -100px;
    left: 30px;
}
.chm-imgDiv{
     position: relative;width: 100px;height: 160px; margin-top:-200px;border: 1px solid #eee;border-radius: 5px;background-color:#eee;opacity:0;box-sizing: border-box;
}
.chm-imgInput{
     width: 100px; height: 160px; cursor: pointer; 
}
.chm-imgTip{
    width:100px;
    background:rgb(245, 105, 24);
    color:#fff;
    height:35px;
    font-size: 13px;
    line-height:35px;
    display:inline-block;
    text-align: center;;
    margin-top:10px;
}
.el-dialog__title{
    font-size: 15px;;
}
 
.el-upload-list--picture-card .el-upload-list__item{
    width:80px ;
    height:80px ;
}
.el-upload--picture-card{
    width:80px ;
    height:80px ;
    line-height:80px ;
}

.ql-container{
    min-height:150px; 
  }
.ql-editor{
	height: 150px;
}
.contentHei .ql-editor{
    height: 450px;
}
#input_box{
	height: 100px;
	padding: 0 10px;
	font-size: 12px;
	word-wrap:break-word;/*为了在ie和FF顺利换行，加上word-wrap*/
	overflow-x:hidden;
	overflow-y: auto; /*visible (默认), hidden, scroll, 和auto*/
	outline:none;
    border:1px solid #ddd;
    border-radius:5px;
    line-height: 15px;
}
#input_box2{
	height: 100px;
	padding: 0 10px;
	font-size: 12px;
	word-wrap:break-word;/*为了在ie和FF顺利换行，加上word-wrap*/
	overflow-x:hidden;
	overflow-y: auto; /*visible (默认), hidden, scroll, 和auto*/
	outline:none;
    border:1px solid #ddd;
    border-radius:5px;
    line-height: 15px;
}
#input_box3{
	height: 100px;
	padding: 0 10px;
	font-size: 12px;
	word-wrap:break-word;/*为了在ie和FF顺利换行，加上word-wrap*/
	overflow-x:hidden;
	overflow-y: auto; /*visible (默认), hidden, scroll, 和auto*/
	outline:none;
    border:1px solid #ddd;
    border-radius:5px;
    line-height: 15px;
}
.imgOper{
    margin-top: -45px; 
    font-size: 18px; 
    float: right;
    margin-right: 20px;
}
.imgOper span{
    margin-right:20px;
}
.imgOper i{
    margin-right:10px;
}
    .el-dialog__body{
        padding:10px 20px;
    }
    .el-dialog__footer{
        padding: 0px 20px 20px;
    }
    .overflowy{

    overflow-x: hidden; /* 设置溢出滚动 */
   white-space: nowrap;
   overflow-y: scroll;
   /* 隐藏滚动条 */
   scrollbar-width: none; /* firefox */
   -ms-overflow-style: none; /* IE 10+ */
}
.overflowy::-webkit-scrollbar {
    display: none; /* Chrome Safari */
 
}
</style>
<style scoped> 
.layerDiv{
    position:fixed;
    height:200px;
    background: #333;
    opacity:0.7;
    z-index:100;
}
.input{
    width:80px;height:27px;line-height:27px;text-align:center;color:#ff2222;border:1px solid #aaa;border-radius:5px;font-weight:700 
}
.input:focus {
    outline:none;
    border: 1px solid #fb8a11;
}
.redSpan{
    width:80px;height:30px;line-height:30px;display:inline-block;text-align:center;color:#ff2222;font-weight:700 
}
.titleInfo{
    width:100%;
    text-align: center;
    line-height: 30px;
    height: 30px;
    font-size: 14px;
    color:#fff; 
    background:#0094d8;
    margin:-10px 0 10px 0; 
}
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    margin-bottom:5px;
    width: 120px;
    display: inline-block;
}

.handle-input {
    margin-bottom:5px;
    width: 180px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

/**/
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
@media screen and (max-width:999px){ 
  
 .goodDetails{
        font-size:12px;line-height:15px;height:18px;overflow-y:auto;
    }
    .goodRight{
        display:block;
    }
} 
@media screen and (min-width:999px){ 
    .goodDetails{
        font-size:15px;line-height:20px;height:22px;overflow-y:auto;
    }
    .goodRight{
        position:absolute;
        left:130px;
    }
}

</style>
